import { render, staticRenderFns } from "./SlideTournament.vue?vue&type=template&id=6cfe095a&scoped=true"
import script from "./SlideTournament.vue?vue&type=script&lang=js"
export * from "./SlideTournament.vue?vue&type=script&lang=js"
import style0 from "./SlideTournament.vue?vue&type=style&index=0&id=6cfe095a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfe095a",
  null
  
)

export default component.exports